module.exports = __webpack_public_path__ + "static/media/instagram-comparativo.1d225501.png";